import { createContext, useState } from "react";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [studentInfo, setStudentInfo] = useState(null);
  const [loginUserEmail, setLoginUserEmail] = useState("");
  const [studentDetails, setStudentDetails] = useState({});
  const [academicRecords, setAcademicRecords] = useState({});
  const [entryTestRecords, setEntryTestRecords] = useState([]);

  return (
    <AppContext.Provider
      value={{
        studentInfo,
        setStudentInfo,
        loginUserEmail,
        setLoginUserEmail,
        studentDetails,
        setStudentDetails,
        academicRecords,
        setAcademicRecords,
        entryTestRecords,
        setEntryTestRecords,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
